//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {windVane} from '../../utils/tmallGenius';
export default {
  components: {},
  beforeRouteEnter(to, from, next) {
    windVane.setNavTitle("使用说明");
    next();
  }
};



// WEBPACK FOOTER //
// ./src/pages/Tutorial/Index.vue